import React from 'react';

// Extracted from StudentProfile.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior). A generic
// confirm/alert dialog driven by a config object the parent builds via
// showCustomModalConfig().
export default function CustomModal({ show, config, onClose, onConfirm }) {
  if (!show) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">
        <div className={`custom-modal-header ${config.type}`}>
          <h3>{config.title}</h3>
          <button className="custom-modal-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        <div className="custom-modal-body">
          <p>{config.message}</p>
        </div>
        <div className="custom-modal-footer">
          {config.showCancel && (
            <button className="custom-modal-btn cancel-btn" onClick={onClose}>
              {config.cancelText}
            </button>
          )}
          <button className={`custom-modal-btn confirm-btn ${config.type}`} onClick={onConfirm}>
            {config.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
